var map = {
	"./ai/7.svg": 509,
	"./computernaya-gramotnost/7.svg": 510,
	"./ege-informatika/7.svg": 511,
	"./frontend/7.svg": 512,
	"./game-design/7.svg": 513,
	"./graphic-design-pro/7.svg": 514,
	"./graphic-design/7.svg": 515,
	"./intensive/7.svg": 516,
	"./osnovy-programmirovaniya/7.svg": 517,
	"./predprinimatelstvo/7.svg": 518,
	"./python/7.svg": 519,
	"./scratch/7.svg": 520,
	"./unity/7.svg": 521,
	"./videoblogging/7.svg": 522,
	"./web-razrabotka/7.svg": 523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 744;